import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

/* FETCH CATEGORIES */
export const fetchCategories = createAsyncThunk(
  "category/fetchCategories",
  async ({ page = 1, limit = 10 }, thunkAPI) => {
    try {
      const res = await api.get(
        `/api/categories?page=${page}&limit=${limit}`
      );
      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to fetch categories");
    }
  }
);

/* FETCH CATEGORY DROPDOWN */
export const fetchCategoryDropdown = createAsyncThunk(
  "category/fetchDropdown",
  async () => {
    const res = await api.get(
      `/api/categories/dropdown`
    );
    return res.data.data;
  }
);

/* CREATE CATEGORY */
export const createCategory = createAsyncThunk(
  "category/createCategory",
  async (formData, thunkAPI) => {
    try {
      const res = await api.post(
        `/api/categories`,
        formData, // ✅ FormData
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to create category");
    }
  }
);


export const deleteCategory = createAsyncThunk(
  "category/delete",
  async (id, thunkAPI) => {
    try {
      const res = await api.delete(`/api/categories/${id}`);
      return id;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Delete failed"
      );
    }
  }
);


/* TOGGLE STATUS */
export const toggleCategoryStatus = createAsyncThunk(
  "category/toggleStatus",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(
        `/api/categories/${id}/status`
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update status");
    }
  }
);

export const updateCategory = createAsyncThunk(
  "category/updateCategory",
  async ({ id, formData }, thunkAPI) => {
    try {
      const res = await api.put(
        `/api/categories/${id}`,
        formData, // ✅ FormData
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update category");
    }
  }
);


/* TOGGLE POPULAR CATEGORY */
export const toggleCategoryPopular = createAsyncThunk(
  "category/togglePopular",
  async (id, thunkAPI) => {
    try {
      const res = await api.patch(
        `/api/categories/${id}/toggle-popular`
      );
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue("Failed to update popular status");
    }
  }
);


const categorySlice = createSlice({
  name: "category",
  initialState: {
    categories: [],
    dropdownCategories: [],
    loading: false,
    error: null,
    pagination: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload.data;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.categories.unshift(action.payload);
      })
      .addCase(toggleCategoryStatus.fulfilled, (state, action) => {
        const index = state.categories.findIndex(
          (c) => c._id === action.payload._id
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.categories = state.categories.filter(
          (cat) => cat._id !== action.payload
        );
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.categories.findIndex(
          (c) => c._id === action.payload._id
        );
        if (index !== -1) {
          state.categories[index] = action.payload;
        }
      })
      .addCase(fetchCategoryDropdown.fulfilled, (state, action) => {
        state.dropdownCategories = action.payload;
      })
      .addCase(toggleCategoryPopular.fulfilled, (state, action) => {
  const index = state.categories.findIndex(
    (c) => c._id === action.payload._id
  );
  if (index !== -1) {
    state.categories[index] = action.payload;
  }
});

  }
});

export default categorySlice.reducer;
